function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.6602 10.44L20.6802 14.62C19.8402 18.23 18.1802 19.69 15.0602 19.39C14.5602 19.35 14.0202 19.26 13.4402 19.12L11.7602 18.72C7.59018 17.73 6.30018 15.67 7.28018 11.49L8.26018 7.30001C8.46018 6.45001 8.70018 5.71001 9.00018 5.10001C10.1702 2.68001 12.1602 2.03001 15.5002 2.82001L17.1702 3.21001C21.3602 4.19001 22.6402 6.26001 21.6602 10.44Z",
  fill: "#E14AC1"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.0603 19.39C14.4403 19.81 13.6603 20.16 12.7103 20.47L11.1303 20.99C7.16034 22.27 5.07034 21.2 3.78034 17.23L2.50034 13.28C1.22034 9.30998 2.28034 7.20998 6.25034 5.92998L7.83034 5.40998C8.24034 5.27998 8.63034 5.16998 9.00034 5.09998C8.70034 5.70998 8.46034 6.44998 8.26034 7.29998L7.28034 11.49C6.30034 15.67 7.59034 17.73 11.7603 18.72L13.4403 19.12C14.0203 19.26 14.5603 19.35 15.0603 19.39Z",
  fill: "url(#paint0_linear_63_11048)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.5723 8.77536L12.5723 8.77536L12.5707 8.77495C12.4447 8.74345 12.3599 8.60955 12.3945 8.47129C12.4259 8.34549 12.5595 8.26077 12.6975 8.29494C12.6977 8.29499 12.6979 8.29504 12.6981 8.29509L17.5465 9.52468L17.5481 9.52509C17.6741 9.55659 17.7589 9.69049 17.7243 9.82875L17.7235 9.83222C17.7002 9.92798 17.599 10.01 17.4894 10.01C17.476 10.01 17.4628 10.0083 17.3965 9.99881L12.5723 8.77536Z",
  fill: "#2B2E33",
  stroke: "#1D1A29"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.5824 12.6454L11.5824 12.6454L11.5804 12.6449C11.4544 12.6134 11.3697 12.4795 11.4042 12.3413C11.4357 12.2155 11.5692 12.1308 11.7072 12.1649L14.6159 12.9046L14.6159 12.9046L14.6179 12.9051C14.7439 12.9366 14.8286 13.0705 14.7941 13.2087L14.794 13.2087L14.7924 13.2155C14.7689 13.3157 14.6817 13.39 14.5592 13.39C14.5458 13.39 14.5326 13.3883 14.4664 13.3788L11.5824 12.6454Z",
  fill: "#2B2E33",
  stroke: "#1D1A29"
});

var _ref6 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_63_11048",
  x1: 8.52333,
  y1: 5.09998,
  x2: 8.52333,
  y2: 21.5023,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4361E8"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#1130B8"
})));

var SvgPriceBoardIconActive = function SvgPriceBoardIconActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPriceBoardIconActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PriceBoardIconActive.3f06b9a7.svg";
export { ForwardRef as ReactComponent };